export const getBase64 = file => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      let encoded = reader.result.replace(/^data:(.*;base64,)?/, '')
      if (encoded.length % 4 > 0) {
        encoded += '='.repeat(4 - (encoded.length % 4))
      }
      resolve(encoded)
    }
    reader.onerror = error => reject(error)
  })
}

export const getExtension = filename => {
  const rx = /.*\.(.+)/g
  const extracted = rx.exec(filename)
  return extracted ? extracted[1].toLocaleLowerCase() : ''
}

const validExtensions = ['jpg', 'jpeg', 'png']

export const isImage = fileExtension => validExtensions.find(extension => extension === fileExtension.toLowerCase())

export const sanitizeFileName = (filename) => {
  const invalidCharacters = /[/\\?%*:|"<>$%#+-=@{}]/g
  return filename.replace(invalidCharacters, '')
}
